



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { SquareFieldState } from '@/types';

@Component
export default class SquareMaterialField extends Vue {
  @Prop() private squareFieldState!: SquareFieldState;

  @Prop() private label!: string;

  @Prop() private fieldName!: string;

  @Prop({ default: false }) private withPlaceholder!: boolean;

  private get fieldMessage(): string | undefined {
    if (this.squareFieldState.errorMessage) {
      return this.squareFieldState.errorMessage;
    }
    if (this.squareFieldState.hasErrors) {
      if (this.squareFieldState.isEmpty) {
        return `${this.fieldName} is required`;
      }
      if (!this.squareFieldState.isCompletelyValid) {
        return `Invalid ${this.fieldName}`;
      }
    }
    return undefined;
  }
}
